<template>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="ADD ADMINISTRATOR"
      @show="resetModal"
      @hidden="resetModal"
      scrollable
      hide-footer
    >
      <div style="position: relative">
      <input
        v-model="name"
        style="width: 100%"
        placeholder="Name"
      >
        <i class="fas fa-search modalSearchIcon"></i>
      </div>
      <div v-if="members.length === 0">No member found </div>
      <div  v-for="member in members" :key="member.customer_id">
          <div
            class="admin-profile mb-2 mt-2"
            :class="{active: selectedMember && selectedMember.customer_id === member.customer_id }"
            @click="chooseAdmin(member)"
          >
            <b-row>
              <b-col cols="2">
                <img class="admin-pic" :src="member.prof_pic" alt="" />
              </b-col>
              <b-col cols="8">
                <p class="admin-username">{{ member.name }}</p>
                <p class="admin-position">{{ member.job_title }}</p>
              </b-col>
            </b-row>
          </div>
        </div>
      <button
        :class="{ ConfirmButtonBisabled: !selectedMember, ConfirmButton: selectedMember}"
        :disabled="selectedMember === null"
        @click="confirmModal"
      >Confirm</button>
    </b-modal>
</template>
<script>

export default {
  props: {
    companyMembers: { type: Array, defoult: [] },
    selectMember: { type: Function },
  },
  data() {
    return {
      name: '',
      selectedMember: null,
      members: [],
    };
  },
  watch: {
    companyMembers: {
      handler(info) {
        if (info) this.members = [...this.companyMembers];
      },
    },
    name: {
      handler(info) {
        const all = [...this.companyMembers];
        if (!info) { return this.members = [...this.companyMembers]; }
        const filteredMembers = all.filter(item => item.name.toLowerCase().includes(info));
        return filteredMembers.length ? this.members = [...filteredMembers] : this.members = [];
      },
    },
  },
  methods: {
    resetModal() {
      this.name = '';
      this.selectedMember = null;
    },
    chooseAdmin(member) {
      this.selectedMember = member;
    },
    confirmModal(e) {
      e.preventDefault();
      this.selectMember(this.selectedMember, 'add');
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
  },
};
</script>
<style src="./css/addAdmin.css" scoped>
</style>
